import { useSelector } from "react-redux";
import type { State } from "@App/state";
import { useQuery } from "@apollo/client";
import { GET_SERVICES, type ServicesQuery } from "@App/graphql/queries";
import { useEffect, useState } from "react";
import { Service } from "@App/types";

export const useServices = () => {
  const organization = useSelector((state: State) => state.orders.organization);
  const [services, setServices] = useState<Service[]>([]);

  const { loading, data, error } = useQuery<ServicesQuery>(GET_SERVICES, {
    variables: {
      organization: organization.id,
    },
  });

  // Set services once in the state when data is loaded to avoid unnecessary re-renders
  useEffect(() => {
    if (!organization || !data) return;
    if (!data) return;

    const sorted = [...data.organization.services].sort(
      (a, b) => a.pivot.sort_order - b.pivot.sort_order,
    );

    // A service can be offered by several of the organization's networks, which returns it once per
    // network. Keep only the first occurrence per service id, i.e. the one with the lowest sort_order.
    const deduplicated = sorted.filter(
      (service, index) => sorted.findIndex((other) => other.id === service.id) === index,
    );

    setServices(deduplicated);
  }, [organization, data]);

  return {
    loading: loading,
    services: services,
    error: error,
  };
};
